import WixSDK from 'shared/utils/wix-sdk';
import { attempt } from 'shared/utils/attempt';

export function getVisitorId() {
  return (
    attempt(() => WixSDK.Utils.getInstanceValue('uid')) ||
    attempt(() => WixSDK.Utils.getInstanceValue('aid')) ||
    ''
  );
}
